import { GetAppOptions } from "../../common/functions/common.functions";
import { createMSALPublicClientApplicationObject } from "../../views/pages/LoginPage/LoginPage.helper";

export const getAcquireMsAccesstoken = async (): Promise<
  string | undefined
> => {
  const masl = createMSALPublicClientApplicationObject();
  const scopes =
    GetAppOptions().AuthDetails.MicrosoftAzureActiveDirectoryOptions.Scopes;

  const account = masl.getActiveAccount() || masl.getAllAccounts()[0];

  if (!account) {
    // No account, redirect to login
    masl.loginRedirect({ scopes: scopes });
    return;
  }

  masl.setActiveAccount(account);

  try {
    const tokenResponse = await masl.acquireTokenSilent({
      scopes: scopes,
      account,
    });
    return tokenResponse.accessToken;
  } catch (error) {
    console.warn("Silent token acquisition failed:", error);
    // Fallback to login redirect
    masl.loginRedirect({ scopes: scopes });
  }
};
